
import * as THREE from 'three';
import { GRID_SIZE } from '../constants';

const WORLD_OFFSET = GRID_SIZE / 2 - 0.5;

export const gridToWorld = (x: number, y: number): [number, number, number] => {
    return [x - WORLD_OFFSET, 0, y - WORLD_OFFSET];
};

export const getHash = (x: number, y: number) => Math.abs(Math.sin(x * 12.9898 + y * 78.233) * 43758.5453) % 1;

export const getRandomRange = (min: number, max: number) => Math.random() * (max - min) + min;

export const applyGrayscale = (color: THREE.Color, factor: number) => {
    if (factor === 0) return color;
    const luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;
    const gray = new THREE.Color(luminance, luminance, luminance);
    return color.lerp(gray, factor);
};
